import EfsTippy from "components/HOCS/EfsTippy";
import CloseBigVideo from "graphics/icons/BigVideo/CloseBigVideo";
import MinimiseBigVideo from "graphics/icons/BigVideo/MinimiseBigVideo";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openToSpaceLayout,
  selectSpaceLayoutValue,
  SPACE_LAYOUT,
  MY_BOARD,
  selectMyLuid,
} from "slices/spaceMediaSlice";
import { setCloseBoard } from "slices/spaceSlice";

const BigVideoCloser = () => {
  const dispatch = useDispatch();
  const spaceLayout = useSelector(selectSpaceLayoutValue);
  const myLuid = useSelector(selectMyLuid);

  if (spaceLayout === SPACE_LAYOUT) return null;
  return (
    <div className="big-video-closer">
      <EfsTippy
        content="Minimise"
        placement="bottom"
        className="small-Tippy grey-Tippy"
        offset={[0, 0]}
        delay={[0, 0]}
      >
        <button onClick={openToSpaceLayout}>
          <MinimiseBigVideo />
        </button>
      </EfsTippy>
      {spaceLayout === MY_BOARD && (
        <EfsTippy
          content="Stop Whiteboard"
          placement="bottom"
          className="small-Tippy grey-Tippy"
          offset={[0, 0]}
          delay={[0, 0]}
        >
          <button onClick={() => dispatch(setCloseBoard(myLuid))}>
            <CloseBigVideo />
          </button>
        </EfsTippy>
      )}
    </div>
  );
};

export default BigVideoCloser;
